import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustedBySection from "./components/TrustedBySection";
import AIPlatformSection from "./components/AIPlatformSection";
import PlatformFeaturesSection from "./components/PlatformFeaturesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import DemoSection from "./components/DemoSection";
import SecuritySection from "./components/SecuritySection";
import Footer from "./components/Footer";
import ROICalculator from "./components/roi/ROICalculator";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <TrustedBySection />
      <AIPlatformSection />
      <PlatformFeaturesSection />
      <TestimonialsSection />
      <DemoSection />
      <SecuritySection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/roi-calculator" element={<ROICalculator />} />
          <Route path="/roi-calculator/results/:resultId" element={<ROICalculator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
